import { CarouselModalSlide, Typography } from '@repo/ui';
import styles from '../ConditionsEducationalModal.module.css';
import MicrobiomeConnectionsSlide from './MicrobiomeConnectionsSlide';
import SensitiveMetricFlagsSlide from './SensitiveMetricFlagsSlide';

export const STATIC_SLIDES: CarouselModalSlide[] = [
  <Typography variant='heading-l' className={styles.headingText}>
    This page shows links between specific microbiome features and certain
    health conditions found in research.
  </Typography>,
  <>
    <Typography variant='heading-l' className={styles.headingText}>
      It is not a diagnosis.
    </Typography>
    <Typography
      variant='body-s'
      className={styles.headingText}
      color='warm-grey-700'
    >
      Flagged metrics do not mean you have or will develop a condition.
    </Typography>
  </>,
  <>
    <Typography variant='heading-l' className={styles.headingText}>
      Certain microbiome patterns may be associated with a condition without
      causing it.
    </Typography>
    <Typography
      variant='body-s'
      className={styles.headingText}
      color='warm-grey-700'
    >
      These microbiome patterns are found in people without this condition too.
    </Typography>
  </>,
  <>
    <Typography variant='heading-l' className={styles.headingText}>
      A flagged metric does not mean a condition is present.
    </Typography>
    <Typography
      variant='body-s'
      className={styles.headingText}
      color='warm-grey-700'
    >
      Factors such as diet, genetics, lifestyle and more can cause flagged
      metrics.
    </Typography>
  </>,
  MicrobiomeConnectionsSlide,
  SensitiveMetricFlagsSlide,
];
